(function($, undefined) {
	'use strict';
	var utils;

	var requestRefund = function() {
		var btn = $(this);
		var errorMsg = btn.closest('.table__cell').find('.form-message_error');
		var requestSent = false;
		var count = 0;
		var tokens = {
			'field1': btn.attr('data-id'),
			'field2': btn.attr('data-payment-id'),
			'field3': btn.attr('data-confirmation-number'),
			'field4': btn.attr('data-quantity') + 'x ' + btn.attr('data-item-name'),
			'field6': utils.formatNumberToMoney(btn.attr('data-amount'))
		};
		if (btn.attr('data-client-name')) {
			tokens.field5 = btn.attr('data-client-name') + ' (' + btn.attr('data-client-email') + ')';
		}

		errorMsg.slideUp();

		btn.attr('data-send-to').split(',').forEach(function(email) {
			utils.sendEmail(email, btn.attr('data-admin-subject'), null, 'refund-request-admin-' + $('html').attr('lang'), tokens, function(response) {
				if (response.indexOf('success') !== -1) {
					requestSent = true;
					btn.slideUp(function() {
						btn.closest('.table__cell').find('.form-message_success').slideDown();
					});
				} else {
					errorMsg.slideDown();
				}
				count++;
			});
		});

		var _success = function() {
			if (count === btn.attr('data-send-to').split(',').length) {
				if (requestSent) {
					utils.sendEmail(btn.attr('data-client-email'), btn.attr('data-client-subject'), null, 'refund-request-client-' + $('html').attr('lang'), tokens, function(response) {});
				}
			} else {
				setTimeout(function() {
					_success();
				}, 300);
			}
		};

		_success();
	};

	var init = function() {
		utils = Fw.component.models().utils;

		$('.request-refund-btn').click(requestRefund);
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
